"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullscreenButtonStyle = void 0;
const typestyle_1 = require("typestyle");
exports.FullscreenButtonStyle = (0, typestyle_1.stylesheet)({
    button: {
        width: '30px',
        minWidth: '30px',
        height: '30px',
        padding: '5px'
    }
});
